import { render, staticRenderFns } from "./show_reimbursemen_itemt_approy.vue?vue&type=template&id=485955be&scoped=true"
import script from "./show_reimbursemen_itemt_approy.vue?vue&type=script&lang=js"
export * from "./show_reimbursemen_itemt_approy.vue?vue&type=script&lang=js"
import style0 from "./show_reimbursemen_itemt_approy.vue?vue&type=style&index=0&id=485955be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485955be",
  null
  
)

export default component.exports